/**
 * Wraps a scheduler so the calls of the orders classes are timed and recorded
 * (feature 334, US3). The wrapped scheduler is untouched and every answer is
 * passed on as it came; `busy` and `stopped` never reached the line, so they
 * are not samples. A timeout or an error counts as a failure, with its duration.
 *
 * Pure TypeScript: the copy under kitchen/expo-app/src/lib/sync must stay byte
 * for byte identical.
 */
import type { Metrics, MetricClass } from "./metrics";
import type { Scheduler } from "./scheduler";

const CLASS_OF: Record<string, MetricClass> = {
  orders_feed: "orders_sync",
  orders_full: "orders_sync",
};

export function meterScheduler(scheduler: Scheduler, metrics: Metrics | undefined, now: () => number = Date.now): Scheduler {
  if (!metrics) return scheduler;
  return {
    nextDelay: (key, intervalMs) => scheduler.nextDelay(key, intervalMs),
    getState: (key) => scheduler.getState(key),
    stop: () => scheduler.stop(),
    async run(key, fn, options) {
      const startedAt = now();
      const result = await scheduler.run(key, fn, options);
      const cls = CLASS_OF[key];
      if (cls && (result.ok || result.reason === "timeout" || result.reason === "error")) {
        metrics.record(cls, now() - startedAt, result.ok);
      }
      return result;
    },
  };
}
